import Decorator from '~/models/decorator'

export default class PublishedProcessFlowDecorator extends Decorator {
}